module.exports = "/_next/static/images/d4a4daf948b38ccc032668c60c06e0a8-woman-using-cellphone@0.75x.jpg.webp";